import * as React from 'react';
import { useDispatch } from 'react-redux';

import { getOffersHistory, openOfferFromHistory, setPage, setRoomsFilter } from '../../../../actions/offersHistory';
import { FILTER_ALL_VALUE, TRoomsFilterOptionValue } from '../../../../types/offerHistory';
import { TThunkDispatch } from '../../../../types/redux';
import { trackFiltersChange } from '../analytics';

/**
 * Хендлер клика по фильтру комнатности
 * */
export const useHandleRoomsFiltersClick = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  return React.useCallback(
    async (e: React.ChangeEvent, value: string) => {
      const _value = value as TRoomsFilterOptionValue;

      dispatch(setRoomsFilter(_value === FILTER_ALL_VALUE ? FILTER_ALL_VALUE : _value));

      dispatch(setPage(1));
      await dispatch(getOffersHistory(false));
      dispatch(trackFiltersChange());
      await dispatch(openOfferFromHistory());
    },
    [dispatch],
  );
};
